import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';
import ComingSoon from './pages/ComingSoon';
// ✅ COMING SOON MODE — mettez false pour lancer le vrai site
const COMING_SOON = false;
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import VerifyEmail from './pages/VerifyEmail';
import AgencyBranding from './pages/AgencyBranding';
import { ClientList, ClientDetail } from './pages/Clients';
import SharedReport from './pages/SharedReport';
import Dashboard from './pages/Dashboard';
import NewAudit from './pages/NewAudit';
import AuditDetail from './pages/AuditDetail';
import Reports from './pages/Reports';
import ReportDetail from './pages/ReportDetail';
import Billing from './pages/Billing';
import Settings from './pages/Settings';
import APIKeys from './pages/APIKeys';
import CGV from './pages/CGV';
import MentionsLegales from './pages/MentionsLegales';
import PolitiqueConfidentialite from './pages/PolitiqueConfidentialite';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import AdminDashboard from './pages/AdminDashboard';
import Domains from './pages/Domains';
import ScheduledScans from './pages/ScheduledScans';
import CheckPage from './pages/CheckPage';
import checkPages from './data/checkPages';
import NotFound from './pages/NotFound';
import CookieConsent from './components/CookieConsent';
import InfoPage from './pages/InfoPage';
import infoPages from './data/infoPages';

// Les rapports partagés sont à la marque de l'agence : ni bandeau ni mesure d'audience CyberGuard.
function SiteCookieConsent() {
  const { pathname } = useLocation();
  return pathname.startsWith('/rapport/') ? null : <CookieConsent />;
}
export default function App() {
  if (COMING_SOON) {
    return (
      <>
        <ComingSoon />
        <Toaster />
      </>
    );
  }
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/rapport/:token" element={<SharedReport />} />
          <Route path="/cgv" element={<CGV />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/confidentialite" element={<PolitiqueConfidentialite />} />
          <Route path="/blog" element={<Blog />} />
          {infoPages.map((p) => (
            <Route key={p.slug} path={`/${p.slug}`} element={<InfoPage slug={p.slug} />} />
          ))}
          <Route path="/blog/:slug" element={<BlogPost />} />
          {checkPages.map((p) => (
            <Route key={p.slug} path={`/${p.slug}`} element={<CheckPage slug={p.slug} />} />
          ))}
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/audits/new" element={<NewAudit />} />
          <Route path="/audits/:id" element={<AuditDetail />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/reports/:id" element={<ReportDetail />} />
          <Route path="/billing" element={<Billing />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/developer/keys" element={<APIKeys />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/domains" element={<Domains />} />
          <Route path="/surveillance" element={<ScheduledScans />} />
          <Route path="/clients" element={<ClientList />} />
          <Route path="/clients/:id" element={<ClientDetail />} />
          <Route path="/agence" element={<AgencyBranding />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <SiteCookieConsent />
      </Router>
      <Toaster />
    </AuthProvider>
  );
}
